import React, { useEffect, useMemo, useState } from 'react'
import { Calendar, momentLocalizer, DateLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment-timezone';
import ContextMenu from '../../../../Scheduler/ContextMenu';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import Loader from '../../../../shared/Loader/Loader';
import useHandleOpenNewBrowserTab from '../../../../shared/NewTabBrowser/useHandleOpenNewBrowserTab';
import DaySchedulePopup from '../DaySchedulePopup/DaySchedulePopup';
import CustomUseRef from '../../../../shared/DropDown/CustomUseRef';
import HandleStatus from '../../../../shared/HandleStatus';
import isNull from '../../../../../utils/NullChecking';
import ContentReceiver from '../../../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver';

const PatientCalendarSummary = (props) => {
    const { isReload, scrollY } = { ...props }

    const localizer = momentLocalizer(moment);
    const API_URL = enumUtil.controller.PATIENT;
    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    const [isMasterWeekOpen, setIsMasterWeekOpen] = useState(false);
    const [masterWeekID, setMasterWeekID] = useState(0)
    let PateintData = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    let PateintIDR = PateintData?.data?.id;

    const [isLoading, setIsLoading] = useState(false);
    const [AppointmetnData, SetAppointmentData] = useState([]);
    const [events, setEvents] = useState([])
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedAppointmentData, setSelectedAppointmentData] = useState({})
    const [showPopup, setShowPopup] = useState(false)
    const [PopupEvents, setPopupEvents] = useState([])
    const [PopupDate, setPopupDate] = useState(new Date())
    const [popupPosition, setPopupPosition] = useState({ top: '', left: '' })
    const [PatientID, setPatientID] = useState(0);
    const [openTab, setOpenTab] = useState('');

    const formats = {
        timeGutterFormat: 'ha', // '7AM';
        weekdayFormat: 'dddd',
        dateFormat: 'DD',
        dayFormat: 'dddd',
    }


    const hanleOnHoverPopup = (e, data) => {
        return (
            <>
                <div className={`appointment-card Processing`}>
                    <div className="appointment-card__head">
                        <div className="appointment-card__head__avatar">
                            <img
                                src={data?.ProfilePicture ? data?.ProfilePicture : "https://www.w3schools.com/howto/img_avatar.png"}
                                alt="avatar"
                            />
                        </div>
                        <div className="appointment-card__head__info">
                            <h4>Name: {data?.PatientName ? data?.PatientName : ''}</h4>
                            <p>ID: {data?.PID ? data?.PID : ''}</p>
                            <p>DOB: {data?.DOB ? data?.DOB : ''}</p>
                            <p>Age: {data?.Age ? data?.Age : ''}</p>
                            <p>Phone No#: {data?.MobileNumber ? data?.MobileNumber : ''}</p>
                        </div>
                    </div>
                    <div className="appointment-card__body">
                        <div className="appointment-card__body__item">
                            <h4>Follow up visit</h4>
                            <p>{data?.AppointmentDate} - {data?.AppointmentStart}</p>
                        </div>
                        <div className="appointment-card__body__item">
                            <h4>Dr. {data?.ProviderFirstName + ' ' + data?.ProviderLastName} </h4>
                            <p> {data?.PrimaryInsurance ? data?.PrimaryInsurance : ''}</p>
                        </div>
                        {/* <div className="appointment-card__body__item">
                    <p>South Medical care</p>
                </div> */}
                        <div className="appointment-card__body__item">
                            <h4>John Peter</h4>
                            {/* <h4>Cigma Health Care</h4> */}

                            <div className="success-pill mt-1">
                                Confirmation — {data?.Confirm ? data?.Confirm : 'N/A'}
                            </div>
                            <div className="success-pill">
                                Eligibility — {data?.Eligibility ? data?.Eligibility : 'N/A'}
                                {/* Eligibility — 11/01/2000 - Active */}
                            </div>

                            <div className="appointment-card__body__item__flex">
                                <div>
                                    <h4>Pt. Balance</h4>
                                    <p>({data?.PatientBalance ? data?.PatientBalance : 'N/A'})</p>
                                </div>
                                <div>
                                    <h4>Ins. Balance</h4>
                                    <p>({data?.InsuranceBalance ? data?.InsuranceBalance : 'N/A'})</p>
                                </div>
                                <div>
                                    <h4>Total. Balance</h4>
                                    <p>({data?.TotalBalance ? data?.TotalBalance : 'N/A'})</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const handleShowMore = (events, date, e) => {

        // const buttonRect = e.target.getBoundingClientRect();
        // setPopupPosition({ top: buttonRect.bottom, left: buttonRect.left });
        setShowPopup(true);
        setPopupEvents(events); // Store events to display in the popup
        setPopupDate(date); // Optionally, store the date for display
    };

    const closeEventsPopup = () => {
        setShowPopup(false);
        setPopupEvents([]); // Store events to display in the popup
        setPopupDate(new Date());
    }

    const handleOpenMasterWeek = (data) => {

        setIsMasterWeekOpen(true);
        setMasterWeekID(data?.PatientAppointmentID);
        setPatientID(data?.PatientID);
        setSelectedAppointmentData(data);
    }

    const handleClaimScreenOpen = (appointment) => {

        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
            },
        };
        setOpenTab(dataObj);
        // handleOpenNewBrowserTab(dataObj);
    }

    const onCloseMasterWeek = () => {
        setIsMasterWeekOpen(false);
    }

    const onCloseMasterWeekSave = () => {
        setIsMasterWeekOpen(false);
        LoadData()
    }

    let MasterWeekPopup = "";
    if (isMasterWeekOpen) {
        MasterWeekPopup = <DaySchedulePopup isMasterWeekOpen={isMasterWeekOpen} onClose={onCloseMasterWeek} onCloseSave={onCloseMasterWeekSave} ID={masterWeekID} patientID={PatientID} data={selectedAppointmentData} />
    }

    function convertTo24Hour(time) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    const handleBreakTime = (time, date) => {
        let TimeNullCheck = isNull(time);
        let DateNullCheck = isNull(date);

        if (TimeNullCheck || DateNullCheck) {
            return "";
        }
        const { hours, minutes } = convertTo24Hour(time)

        const formatedHours = String(hours).padStart(2, '0');

        const day = date.split('/')[1];
        const month = (date.split('/')[0] - 1);
        const year = date.split('/')[2];
        const formatedDate = new Date(year, month, day, formatedHours, minutes);
        return formatedDate;

    }
    const CustomEvent = ({ eventsProps, onShowMore }) => {
        // Limit the number of events to display
        const displayedEvents = events.slice(0, 2);
        const remainingCount = events.length - 2;

        return (
            <div>
                {displayedEvents.map((event, index) => (
                    <div key={index} className="custom-event">
                        {event.title}
                    </div>
                ))}
                {remainingCount > 0 && (
                    <button onClick={onShowMore} className="show-more">
                        +{remainingCount} more
                    </button>
                )}
            </div>
        );
    };
    const handleAppointment = (dataArray, date) => {
        let updatedArray = []

        if (dataArray instanceof Array && dataArray?.length > 0) {
            updatedArray = dataArray?.map((appointment) => {

                let filteredArray = dataArray?.filter((item) => item?.AppointmentDate === appointment?.AppointmentDate)
                let ClaimSubScreenData = {

                    name: 'Claims',
                    data: {
                        id: appointment?.ClaimID + "",
                        name: appointment?.PatientName,
                        VisitType: appointment?.ClaimType,
                        ClaimRecord: { ID: appointment?.ClaimID + "", name: appointment?.Patient, ClaimType: appointment?.ClaimType, EncounterID: appointment.EncounterID + ""  },
                    }
                };

                let CaregiverSubScreenData = {
                    key: 2,
                    name: "Caregiver",
                    active: true,
                    data: {
                        id: appointment?.ClaimCareGiverID,
                        name: appointment?.ClaimCareGiver,
                        time: new Date(),
                    },
                };

                return {
                    title: (
                        <>
                            {
                                // filteredArray?.length > 1 ?

                                //     <div className={`calender-inner-popup ${appointment?.ValidationMsg ? 'else' : ''}`} onMouseEnter={(e) => hanleOnHoverPopup(e, appointment)}>
                                //         {appointment?.PatientAppointmentID &&
                                //             <div className="d-flex justify-content-between align-items-center br-bottom-1 br-clr-light pb-2px" onClick={() => handleOpenMasterWeek(appointment)}>
                                //                 <p className="heading font-m za-blue-clr ">S.T: {" " + appointment?.STStart + " "} to {" " + appointment?.STEnd + " "}</p>


                                //             </div>

                                //         }

                                //         {appointment?.ClaimID &&
                                //             <div onClick={() => appointment?.ClaimID && handleOpenNewBrowserTab(ClaimSubScreenData)}>
                                //                 <div className=" d-flex justify-content-between align-items-center py-2px px-2px" >
                                //                     <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-call fs-14'></i> <span className='font-m'>V.T: &nbsp;</span> <span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p>
                                //                     <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-locat fs-14'></i><span className='font-m'>V.T: &nbsp;</span><span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p>
                                //                     <p className="text arlight-color d-flex align-items-center">
                                //                         <i className="icon-Vector123 fs-11 fot-m"></i> <span className='font-m'>V.T: &nbsp;</span> <span className="green-text font-r">{appointment?.VTStart}</span>&nbsp;-&nbsp;<span className="red-text font-r">{appointment?.VTEnd}</span>

                                //                     </p>

                                //                 </div>

                                //                 {appointment?.ClaimCareGiverID &&
                                //                     <div className="d-flex justify-content-between align-items-center px-2px pb-2px" >
                                //                         <p className="text fs-11">{appointment?.VTTime}|{appointment?.Units ? appointment?.Units + " U " : ""}</p>
                                //                         <p className="text fs-11" onClick={(e) => { e.stopPropagation(); handleOpenNewBrowserTab(CaregiverSubScreenData) }}>{appointment?.ClaimCareGiverFirstName}</p>
                                //                     </div>}
                                //                 <div className="d-flex align-items-center justify-content-between">
                                //                     <p className='Paid heading ar-status-clm'>{appointment?.BillingStatus}</p>
                                //                     {appointment?.ValidationMsg && <div className="icon-copy position-relative">
                                //                         <i className="bi bi-info-circle-fill fs-13"></i>
                                //                         <p class="tool_tip xsm_text text-light">{appointment?.ValidationMsg}</p>
                                //                     </div>}
                                //                 </div>
                                //             </div>
                                //         }
                                //     </div>
                                //     :

                                <div className={`calender-inner-popup  position-relative ${appointment?.ValidationMsg ? 'else' : ''}`} onMouseOver={(e) => hanleOnHoverPopup(e, appointment)}>

                                    {appointment?.PatientAppointmentID &&
                                        <div className="d-flex justify-content-between align-items-center" onClick={() => handleOpenMasterWeek(appointment)}>
                                            <p className="heading font-m za-blue-clr ">S.T: {" " + appointment?.STStart + " "} - {" " + appointment?.STEnd + " "}</p>

                                            {appointment?.MissVisitStatus ? <div className="za-denied-status Inner-popup position-relative d-flex">
                                                <i className='icon-Missed-visit fs-13'></i>
                                                <p className='xsm_text text-light tool_tip'>{appointment?.MissVisitStatus}</p>
                                            </div> : <></>}
                                        </div>
                                    }

                                    {appointment?.ClaimID &&
                                        <div className={appointment?.PatientAppointmentID && `br-top-1 br-clr-light`} onClick={() => appointment?.ClaimID && handleOpenNewBrowserTab(ClaimSubScreenData)}>

                                            <div className=" d-flex justify-content-between align-items-center py-2px px-2px" >
                                                {/* <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-call fs-14'></i><span className='font-m'>V.T: &nbsp;</span> <span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p> */}
                                                {/* <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-locat fs-14'></i><span className='font-m'>V.T: &nbsp;</span><span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p> */}
                                                <p className="text arlight-color d-flex align-items-center">
                                                    <i className="icon-Vector123 fs-11 fot-m"></i><span className='font-m'>V.T: &nbsp;</span><span className="green-text font-r">{appointment?.VTStart}</span>&nbsp;-&nbsp;<span className="red-text font-r">{appointment?.VTEnd}</span>

                                                </p>
                                            </div>


                                            <div className="d-flex justify-content-between align-items-center px-2px pb-2px" >
                                                <p className="text fs-11">{appointment?.VTTime} | {appointment?.Units ? appointment?.Units + " U " : ""} </p>
                                                {appointment?.ClaimCareGiverID && <p className="text fs-11" onClick={(e) => { e.stopPropagation(); handleOpenNewBrowserTab(CaregiverSubScreenData) }}>{appointment?.ClaimCareGiverFirstName}</p>}
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                {/* <p className=''>{HandleStatus(appointment?.BillingStatus)}</p> */}
                                                <p className=''><HandleStatus Status={appointment?.BillingStatus} /></p>
                                                {appointment?.ValidationMsg && <div className="icon-copy position-relative">
                                                    <i className="bi bi-info-circle-fill fs-13"></i>
                                                    <p class="tool_tip xsm_text text-light">{appointment?.ValidationMsg}</p>
                                                </div>}
                                            </div>
                                        </div>
                                    }

                                    {/* <div className="appointment-card Processing">
                                        <div className="appointment-card__head">
                                            <div className="appointment-card__head__avatar">
                                                <img
                                                    src="https://www.w3schools.com/howto/img_avatar.png"
                                                    alt="avatar"
                                                />
                                            </div>
                                            <div className="appointment-card__head__info">
                                                <div className="d-flex justify-content-between align-items-center w-100">
                                                    <p className="heading fs-11 drk-green-clr">{appointment?.PatientName}</p>
                                                    <p className="text font-m fs-11 fst-italic ar-light-color">{appointment?.AccountNumber}</p>
                                                </div>
                                                <p className="text font-m fs-11 fst-italic drk-green-clr">{appointment?.PrimaryInsurance}</p>
                                                <div className="d-flex align-items-center gap col-md-8">
                                                    <p className="heading fs-10 ar-light-color">Medicaid #</p>
                                                    <p className="text font-m fs-10">{appointment?.MedicaidNo}</p>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex align-items-center col-md-9 gap-01">
                                                        <p className="heading fs-10 ar-light-color">Member ID:</p>
                                                        <p className="text font-m fs-10">{appointment?.MemberID}</p>
                                                    </div>
                                                    <div className="d-flex align-items-center col-md-3">
                                                        <p className="heading fs-10 ar-light-color text-nowrap">Auth # 1234</p>
                                                        <p className="text font-m fs-10">{appointment?.Auth}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="appointment-card__body">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="col-md-5 d-flex align-items-center justify-content-between">
                                                    <p className="text fs-11 font-m drk-green-clr">Schedule </p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.AppointmentDate}</p>
                                                </div>
                                                <div className="col-md-5 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Duration</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.STTime}</p>
                                                </div>

                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="col-md-5 d-flex align-items-center justify-content-between">
                                                    <p className="text fs-11 font-m drk-green-clr">Visit </p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.VisitDate}</p>
                                                </div>
                                                <div className="col-md-5 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Duration</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.VTTime}</p>
                                                </div>
                                                <div className="col-md-2 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Unit</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.Units}</p>
                                                </div>

                                            </div>
                                            <div className="">
                                                <div className="col-md-8 d-flex align-items-center justify-content-between">
                                                    <p className="text fs-11 font-m drk-green-clr">Caregiver</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.ClaimCareGiver}</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="col-md-5 d-flex align-items-center justify-content-between gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Submitted  </p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.SubmittedDate}</p>
                                                </div>
                                                <div className="col-md-5 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Batch #</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.EDIClaimBatchID}</p>
                                                </div>

                                            </div>

                                            <div className="appointment-card__body__item">
                                                <p className="heading fs-11 drk-green-clr">ICD(s)</p>
                                                {appointment?.ICDS && <div className="success-pill mt-1">
                                                    <p className="heading fs-9 text-white">  {appointment?.ICDS}</p>
                                                </div>}
                                                <p className="heading fs-11 drk-green-clr mt-1">CPT(s)</p>
                                                <div className="success-pill mt-1 d-flex align-items-center gap-01">
                                                    <p className="text font-m fs-9 text-white"><span className="heading fs-9 text-white">A089 </span> | Amt: <span className="heading fs-9 text-white"> $0.00</span> | Paid Amt: <span className="heading fs-9 text-white">$0.00 </span> | Status:</p>

                                                    <p className='Paid heading ar-status-clm'>Paid</p>
                                                </div>
                                                <div className="success-pill mt-1 d-flex align-items-center gap-01">
                                                    <p className="text font-m fs-9 text-white"><span className="heading fs-9 text-white">A089 </span> | Amt: <span className="heading fs-9 text-white"> $0.00</span> | Paid Amt: <span className="heading fs-9 text-white">$0.00 </span> | Status:</p>

                                                    <p className='Paid heading ar-status-clm'>Paid</p>
                                                </div>
                                                <div className="d-flex gap-01">
                                                    <p className="text font-m fs-11 drk-green-clr ">Notes:</p>
                                                    <p className="text fs-10 font-r ar-light-color text-nowrap validation_message">Lorem Ipsum xbsb hsajdh lorem jahjs kjkjak hs Lorem Ipsum xbsb hsajdh lorem jahjs kjkjak hsy....</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                </div>
                            }


                        </>

                    ),
                    start: !isNull(appointment?.PatientAppointmentID) ? handleBreakTime(appointment?.AppointmentStart, appointment?.AppointmentDate) : !isNull(appointment?.ClaimID) ?  handleBreakTime(appointment?.VTStart_12H, appointment?.VisitDate)  : "",
                    end: !isNull(appointment?.PatientAppointmentID) ? handleBreakTime(appointment?.AppointmentEnd, appointment?.AppointmentDate) : !isNull(appointment?.ClaimID) ?  handleBreakTime(appointment?.VTEnd_12H, appointment?.VisitDate)  : "",
                    data: {
                        PatientName: appointment?.PatientName,
                        VisitDate: appointment?.VisitDate,
                        VisitStart: appointment?.VisitStart,
                        BillingStatus: appointment?.BillingStatus,
                        STEnd: appointment?.STEnd,
                        STStart: appointment?.STStart,
                        ClaimCareGiver: appointment?.ClaimCareGiver,
                        ValidationMsg: appointment?.ValidationMsg
                    },

                }
            })
        }
        return updatedArray
    }

    useEffect(() => {
        let data = handleAppointment(AppointmetnData, currentDate);
        // console.log("data", data)
        // return data
        setEvents(data);
    }, [AppointmetnData])
    // [
    //     {
    //         title: (
    //             <div className='calender-inner-popup'>
    //                 <div className='d-flex justify-content-between align-items-center br-bottom-1 br-clr-light-light pb-2'>
    //                     <p className='heading'>S.T: 08:00 to 10:00</p>
    //                     <p className='text fst-italic font-m fs-10 Submitted'>Submitted</p>
    //                 </div>
    //                 <p className='text arlight-color py-2'>V.T: <span className='green-text'>08:00</span> to <span className='red-text'>10:02 </span> </p>
    //                 <p className='text arlight-color text-decoration-underline'>Clay Anderson</p>
    //                 <div className="text-end pe-1 icon-copy position-relative">
    //                     <i className='bi bi-info-circle-fill fs-15'></i>
    //                     <p class="tool_tip xsm_text text-light">Memberid is Missing  </p>
    //                 </div>
    //             </div>),
    //         start: new Date(2024, 4, 27, 11, 0),
    //         end: new Date(2024, 4, 27, 12, 0),
    //     },

    //     {
    //         title: (
    //             <div className='calender-inner-popup'>
    //                 <div className='d-flex justify-content-between align-items-center br-bottom-1 br-clr-light-light pb-2'>
    //                     <p className='heading'>S.T: 08:00 to 10:00</p>
    //                     <p className='text fst-italic font-m fs-10 Submitted'>Submitted</p>
    //                 </div>
    //                 <p className='text arlight-color py-2'>V.T: <span className='green-text'>08:00</span> to <span className='red-text'>10:02 </span> </p>
    //                 <p className='text arlight-color text-decoration-underline'>Clay Anderson</p>
    //                 <div className="text-end pe-1 icon-copy position-relative">
    //                     <i className='bi bi-info-circle-fill fs-15'></i>
    //                     <p class="tool_tip xsm_text text-light">Memberid is Missing  </p>
    //                 </div>
    //             </div>),
    //         start: new Date(2024, 4, 27, 11, 0),
    //         end: new Date(2024, 4, 27, 12, 0),
    //     },

    // ];

    let initialContext = {
        event: null,
        show: false,
        x: 0,
        y: 0,
    }
    ///////////////////////////
    const [contextMenuProvider, setContextMenuProvider] = useState(initialContext);
    // const [myEvents, setEvents] = useState(events)

    const handleNextWeek = () => {
        const nextMonth = moment(currentDate).add(1, 'month').toDate();
        setCurrentDate(nextMonth);
    }

    const handlePrevWeek = () => {
        const prevMonth = moment(currentDate).subtract(1, 'month').toDate();
        setCurrentDate(prevMonth);
    }

    const handleNavigate = (date) => {
        setCurrentDate(date);
    }

    const handleContextMenu = (e, prov, event, type) => {
        e.preventDefault();
        e.stopPropagation();
        const xPos = e.clientX + 160;
        const yPos = e.clientY - 150;
        setContextMenuProvider({ event: event, show: true, x: xPos, y: yPos, type: type });
    }


    const LoadData = () => {
        SetAppointmentData([])
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.PatientCalendar,
            "SearchCriteria": {
                "PatientID": PateintIDR + "",
                "PatientIDs": null,
                "CareGiverID": null,
                "CareGiverIDs": null,
                "Year": currentDate.getFullYear() + '',
                "Month": currentDate.getMonth() + 1 + '',
                "Datefrom": null,
                "DateTo": null
            }
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/CalendarDetails', 'post', saveModal)
            .then((response) => {
                setIsLoading(false);
                SetAppointmentData(response)
                // console.log("repsonse", response)
            }).catch((error) => {
                setIsLoading(false);
                SetAppointmentData([]);
                // console.log("error", error)
            })
    }

    // useEffect(() => {
    //     LoadData();
    // }, [currentDate, isReload])

    useEffect(() => {
        if (!isNull(props?.Reload?.Reload)) {

            let data = props?.Reload?.id
            data?.map((item) => {
                if (item.key === 217) {
                    LoadData()
                }
            })
        }
    }, [props?.Reload?.Reload, currentDate])


    return (
        <div>
            <div className=' position-relative'>
                {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
                {MasterWeekPopup}
                <div className='ar_header'>
                    <p className='heading fs-13'>Calendar</p>
                </div>
                <div className='ar-top-btn-position d-flex align-items-center'>
                    {/* <div className='side-view h-100'></div> */}
                    <div className='d-flex align-items-center gap-15 ms-2'>
                        <>
                            <span className='heading'>
                                {moment(currentDate).format('MMMM YY')}
                            </span>
                        </>
                        <div className='d-flex align-items-center gap-10'>
                            <div className='CP_toggle d-flex align-items-center justify-content-center cursor-pointer' onClick={handlePrevWeek}><i className='icon-angle-left me-1 fs-10 cursor-pointer'></i></div>
                            <div className='CP_toggle  d-flex align-items-center justify-content-center cursor-pointer' onClick={handleNextWeek}> <i className='icon-angle-right fs-10 cursor-pointer'></i></div>
                        </div>
                    </div>
                </div>

                {contextMenuProvider.show ? <ContextMenu contextMenuProvider={contextMenuProvider} setContextMenuProvider={setContextMenuProvider} scrollY={scrollY} handleOpenMasterWeek={handleOpenMasterWeek} handleClaimScreenOpen={handleClaimScreenOpen} /> : null}
                <div className='hk-EA-calender'>

                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        style={{ height: 'auto', overflow: 'visible' }}
                        defaultView={"month"}
                        formats={formats}
                        date={currentDate}
                        toolbar={false}
                        tooltipAccessor={null}
                        allDayMaxRows={1}
                        popup={true}
                        view={"month"}
                        // popupOffset={{ x: 150, y: 150 }}
                        // onShowMore={(events, date, clickEvent) => {
                        // Custom logic for handling "show more" behavior
                        // const moreButton = document.querySelector('.rbc-show-more');
                        // handleShowMore(events, date, clickEvent)
                        // }}
                        components={{
                            // event: EventComponent,
                            month: {
                                dateHeader: function CustomDateHeader(props) {
                                    // events?.filter(item => console.log("object",item));
                                    return (
                                        <span onClick={(e) => handleContextMenu(e, null, props, 'dateWrapper')} className='rbc-button-link'>
                                            {props?.label}
                                        </span>
                                    )
                                }
                            },
                            eventWrapper: ({ event, children }) => (
                                <div className='events'

                                    onContextMenu={
                                        e => {
                                            handleContextMenu(e, event, "eventWrapper");
                                            e.preventDefault();
                                        }
                                    }
                                >
                                    {children}

                                </div>
                            ),
                            // timeSlotWrapper: ({
                            //     children,
                            //     value,
                            //     resource,
                            // }) => {
                            //     return React.cloneElement(children, {
                            //         // children: (
                            //         //     <>
                            //         //         {/* Your dynamic content goes here */}
                            //         //         <p>{handleSteps(list.value)}!</p>
                            //         //         {children.props.children}
                            //         //     </>
                            //         // ),
                            //         onContextMenu: (e) => {
                            //             e.preventDefault();
                            //             handleContextMenu(e,  value, "timeSlotWrapper");
                            //         },
                            //     });

                            // },
                            // timeGutterWrapper: CustomTimeGutterWrapper,
                        }
                        }
                    />

                </div>
            </div >
            {isLoading ? <Loader /> : <></>}
        </div >

    )
}

export default PatientCalendarSummary

